import { push } from '@lagunovsky/redux-react-router'
import { H_RPQS_DASHBOARD, H_RPQS_MODULE, H_RPQS_OPTIONS } from 'account/constants/AccessRulesConstants'
import { ALIGN } from 'components/datatable/NewTable'
import FixedSlideNav from 'components/navbar/FixedSlideNav'
import BoundaryError from 'log/components/BoundaryError'
import React, { useEffect, useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { Outlet } from 'react-router'
import CollectivityAction from 'rpqs/actions/CollectivityAction'
import i18n from 'simple-react-i18n'
import { componentHasHabilitations } from 'utils/HabilitationUtil'

const RpqsApp = () => {
    const dispatch = useDispatch()

    const navLinks = useMemo(() => {
        return [{
            icons: 'dashboard',
            name: i18n.dashboard,
            href: '/rpqs/dashboard',
            habilitation: H_RPQS_DASHBOARD,
        }, {
            icons: 'settings',
            name: i18n.settings,
            href: '/rpqs/option',
            habilitation: H_RPQS_OPTIONS,
            position: ALIGN.BOTTOM,
        }]
    }, [])

    useEffect(() => {
        if (!componentHasHabilitations(H_RPQS_MODULE)) {
            dispatch(push('/unauthorized'))
            return
        }

        dispatch(CollectivityAction.fetchCollectivities())
    }, [dispatch])

    return (
        <div className='row no-margin'>
            <FixedSlideNav links={navLinks} />
            <main>
                <div className='row no-margin padding-left-1'>
                    <div className='content-page no-padding fullscreen'>
                        <BoundaryError>
                            <Outlet />
                        </BoundaryError>
                    </div>
                </div>
            </main>
        </div>
    )
}

export default RpqsApp